import { parseStoredAuthContext } from "@components/utils/authEmployeeContext";
import { normalizeBadgeLevel } from "@components/utils/normalizeBadgeLevel";
import { normalizeAdminPermission } from "@/utils/defaultLoggedInRedirect";

export const APPOINTED_ISSUED_METHOD = "appointed";

export const APPOINT_DIALOG_HEADER =
  "Appointing a badge means the appointed badge will never become obsolete.";

export const SELF_APPOINT_PROMPT_TEXT =
  "You just activated a checkpoint and you do not have a current Architect for this responsibility. As an administrator, do you want to give yourself an Architect badge?";

// Accepts the stable keys (proficient/architect), the legacy API strings
// (professional/master) and the 1..4 level numbers.
const BADGE_LEVEL_NUMBERS = { apprentice: 1, proficient: 2, coach: 3, architect: 4 };

export function getBadgeLevelNumber(level) {
  return BADGE_LEVEL_NUMBERS[normalizeBadgeLevel(level)] || 0;
}

export function isAppointedBadge(badge) {
  return String(badge?.issued_method ?? "").toLowerCase() === APPOINTED_ISSUED_METHOD;
}

/** Dot label for a badge: an Appointed badge in good standing shows the Appointed diamond. */
export function resolveAppointedDot(badge, dot) {
  return isAppointedBadge(badge) && dot === "Good Standing" ? "Appointed" : dot;
}

/** True when the stored access permission is owner, co-owner or administrator. */
export function isCurrentUserAdmin() {
  const { accessPermission } = parseStoredAuthContext();
  return normalizeAdminPermission(accessPermission).hasElevatedNav === true;
}

export function buildAppointBadgePayload({ employeeId, responsibilityId, level, notify = false }) {
  return {
    employee: employeeId,
    responsibility: responsibilityId,
    level: getBadgeLevelNumber(level),
    given: true,
    issued_method: APPOINTED_ISSUED_METHOD,
    notify: notify === true,
  };
}
